<template>
  <a-modal
    v-model:open="open"
    width="1200px"
    centered
    :footer="false"
    :closable="false"
    :destroyOnClose="true"
    wrapClassName="xmov-empty-modal"
    @cancel="close"
  >
    <TemplateDetail v-if="!ssrPlaceholder" />
    <CloseOutlined v-if="!ssrPlaceholder" :class="CloseIconOutClass" @click="close" />
  </a-modal>
</template>

<script lang="ts" setup>
import { CloseIconOutClass } from '~/hooks/useModal/modals/closeIcon';
import { TemplateDetail } from './detail';

const props = withDefaults(
  defineProps<{
    /** SSR 时传 true，渲染相同根节点避免 hydration mismatch */
    ssrPlaceholder?: boolean;
  }>(),
  { ssrPlaceholder: false },
);

const open = useTemplateVisible();

const close = () => {
  useTemplateCancel();
};
</script>
